export default __webpack_public_path__ + "67dd0c0d17a887a6937be6d067ae4e52.svg";